import React, { Component } from "react";
import { Modal } from "antd";
import TTPModal from "../Common/Modal/TTPModal";
import styles from "./SlideCompositionPage.local.scss";
import { connect } from "react-redux";
import Slide from "../Dashboard/Slide";
import _ from "i18n";

const { confirm } = Modal;

class ShowSlideModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true
    };
  }

  handleCancelSlideModal = () => {
    const { disabled } = this.state;
    if (!disabled) {
      confirm({
        title: _("cancelConfirm"),
        onOk: () => {
          this.props.handleCancelModal();
          this.setState({ disabled: true });
        },
        onCancel() {}
      });
    } else {
      this.props.handleCancelModal();
      this.setState({ disabled: true });
    }
  };
  render() {
    const { fetching, fetched, slide } = this.props;
    return (
      <TTPModal
        title={_("slideView")}
        visible={this.props.isVisible}
        loading={false}
        handleCancel={this.handleCancelSlideModal}
        width={1390}
      >
        {fetched && (
          <Slide
            key="1"
            slide={slide}
            isResponsive={false}
            isComposition={true}
            isPresentation={false}
            inSlideView={true}
          />
        )}
        {fetching && (
          <div className={styles.ripple_loading}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}{" "}
      </TTPModal>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.slideComposition.fetchSlide.fetching,
  fetched: state.slideComposition.fetchSlide.fetched,
  slideId: state.slideComposition.composition.slideId,
  slide: state.slideComposition.composition
});

export default connect(mapStateToProps)(ShowSlideModal);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/ShowSlideModal.js